export default __webpack_public_path__ + "static/media/AiCollab.9746667d.gif";